import React from 'react';
import { Form, Input } from 'antd';

const ProfilePosition = ({ form }) => {
  const { getFieldDecorator } = form;
  return (
    <div className="client-type__form new" style={{ marginBottom: 16 }}>
      <div className="offer-card__item">
        <span className="label">Должность:</span>
        <Form.Item>
          {getFieldDecorator('role')(
            <Input
              style={{ width: 224 }}
              placeholder="Укажите должность"
              disabled
            />
          )}
        </Form.Item>
      </div>
    </div>
  );
};

export default ProfilePosition;
